import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildLeadUrl = (endpoint) =>
  `/book/lead_notifies${endpoint && endpoint.toString().length > 0 ? `/${endpoint}` : ""}`

export const leadNotifiesService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLeadNotifies: builder.query({
      query: (params) => {
        const cleaned = Object.fromEntries(
          Object.entries(params).filter(
            ([_, v]) => v !== null && v !== 0 && !(Array.isArray(v) && v.length === 0)
          )
        )
        return {
          url: buildLeadUrl("list_combined"),
          method: "GET",
          params: cleaned,
        }
      },
    }),

    getLeadChatDetail: builder.query({
      query: (params) => ({
        url: buildLeadUrl("chat_detail"),
        method: "GET",
        params: { lead_id: params.bundle_id }, // bundle_id используется как lead_id внутри хука
      }),
    }),

    createLeadNotify: builder.mutation({
      query: ({ bundle_id, message, files, for_admin, to_client, reply_to_id }) => {
        const formData = new FormData()
        formData.append("lead_id", bundle_id)
        formData.append("message", message)
        formData.append("for_admin", for_admin ?? false)
        formData.append("to_client", to_client ?? false)
        if (reply_to_id != null) formData.append("reply_to_id", reply_to_id)
        if (files?.length) {
          files.forEach((file) => formData.append("files[]", file))
        }
        return {
          url: buildLeadUrl(""),
          method: "POST",
          body: formData,
        }
      },
    }),

    toggleLeadReadMessage: builder.mutation({
      query: (id) => ({
        url: buildLeadUrl(`${id}/toggle_read`),
        method: "PATCH",
      }),
    }),

    getLeadChatMeta: builder.query({
      query: () => ({
        url: buildLeadUrl("meta"),
        method: "GET",
      }),
    }),
  }),
})

export const {
  useGetLeadNotifiesQuery,
  useLazyGetLeadNotifiesQuery,
  useLazyGetLeadChatDetailQuery,
  useGetLeadChatDetailQuery,
  useCreateLeadNotifyMutation,
  useToggleLeadReadMessageMutation,
  useGetLeadChatMetaQuery,
} = leadNotifiesService
